import '../styles.css';
import { sum } from './utils.js';


const CustomRowVertical = ( props ) => {
  return (
    <tr className="custom-row-th-vertical" {...props} />
  )
};

const CustomRowHorizontal = ( props ) => {
  return (
    <tr className="custom-row-th-horizontal" {...props} />
  )
};

const validateNumericCell = ( value ) => {
  return !isNaN(value) || value === undefined;
};

const validateTextCell = ( value ) => {
  return (value === '' || typeof value === 'string') || value === undefined;
};

const validateShirtCell = ( value, allowedValues ) => {
  return (value === '' || sum(allowedValues.map(s => s === value ? 1 : 0)) > 0 || value === undefined);
};

export {
    CustomRowVertical, 
    CustomRowHorizontal,
    validateNumericCell,
    validateTextCell,
    validateShirtCell
}